<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="registrationValidator">
        <form @submit.prevent="handleSubmit(submit)"
            @keydown="errors.clear($event.target.name)"
        >

            <base-select class="mb-4" v-if="!updating || duplicating"
                :label="$t('common.cohort')"
                :placeholder="$t('common.cohort')"
                label-classes="required"
                v-model="value.cohort_id"
                :options="cohorts"
                :filterable="true"
                :scroll="true"
                @input="errors.clear('cohort_id')"
                :error="errors.get('cohort_id')"
            >
            </base-select>

            <base-input class="mb-3" v-else
                :label="$t('common.cohort')"
                label-classes="form-control-label required"
                v-model="value.cohort.name"
                :disabled="true"
            >
            </base-input>

            <base-select class="mb-4" v-if="!updating || duplicating"
                :label="$t('common.degree')"
                :placeholder="$t('common.degree')"
                label-classes="required"
                v-model="value.degree_id"
                :options="degreesSelect"
                :filterable="true"
                :scroll="true"
                :notes="degreesSelectNotes"
                @input="errors.clear('degree_id')"
                :error="errors.get('degree_id')"
            >
            </base-select>

            <base-input class="mb-3" v-else
                :label="$t('common.degree')"
                label-classes="form-control-label required"
                v-model="value.degree.name"
                :disabled="true"
            >
            </base-input>

            <base-select class="mb-4" v-if="duplicating || (value.status != 'closed' && value.status != 'archived')"
                :label="$t('common.status')"
                :placeholder="$t('common.status')"
                v-model="value.status"
                :options="statusOptions"
                :sort="false"
            >
            </base-select>

            <base-checkbox class="mb-3" v-model="value.track" v-if="duplicating || !validation">
                {{ $t('registrations.track') }}
            </base-checkbox>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center" v-if="duplicating">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ $t('common.duplicate') }}
                </base-button>

                <base-button type="link" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

            <div class="text-center" v-if="!duplicating">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ updating ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                default: null
            },

            duplicating: {
                type: Boolean,
                default: false
            },

            statusOptions: {
                type: Object,
                default: true
            },

            cohorts: {
                type: Object,
                required: true
            },

            degrees: {
                type: Object,
                required: true
            },

            validation: {
                type: Boolean,
                default: false
            },
        },

        created() {
            this.errors.setValidator('registrationValidator', this)
        },

        computed: {

            updating() {
                return this.value.id != undefined
            },

            degreesSelect() {
                const degreesSelect = {}
                for (const degreeId in this.degrees) {
                    degreesSelect[degreeId] = this.degrees[degreeId].name
                }
                return degreesSelect
            },

            degreesSelectNotes() {
                const degreesSelect = {}
                for (const degreeId in this.degrees) {
                    if (this.degrees[degreeId].edition) {
                        degreesSelect[degreeId] = this.degrees[degreeId].edition + ' (' + this.degrees[degreeId].lang + ')'
                    } else {
                        degreesSelect[degreeId] = '(' + this.degrees[degreeId].lang + ')'
                    }
                }
                return degreesSelect
            }
        },

        methods: {
            submit() {
                if (this.duplicating) {
                    this.$loader.show()
                }
                this.$emit('input', { ...this.value})
            },

            next() {
                this.$emit('next')
                this.submit()
            }
        }
    }
</script>
